export const SET_INVITE_FRIEND_STATUS = 'SET_INVITE_FRIEND_STATUS';
export const SET_INVITE_FRIEND_ADDRESS = 'SET_INVITE_FRIEND_ADDRESS';

